import { path } from 'ramda';

import localizeLink from 'app/features/localization/localizeLink';

const redirectIfNotOnPath = (to, locale) => {
  const currentPath = path(['location', 'pathname'], window);
  const redirectUrl = locale ? localizeLink(to, locale) : to;

  if (redirectUrl && currentPath !== redirectUrl) {
    window.location.assign(redirectUrl);
  }
};

const ExternalRedirect = ({ to, locale }) => {
  redirectIfNotOnPath(to, locale);

  return null;
};

export { redirectIfNotOnPath };

export default ExternalRedirect;
